module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp23_7.e3b9f7f9.png";